import React from "react";
import PropTypes from "prop-types";
import { defaultTemplate } from "core/hoc";
import {
    BaasicTable,
    TableFilter
} from "core/components";
import { ApplicationListLayout, Content, PageNavigation } from "core/layouts";
import { DateRangeQueryPicker, QueryDropdown } from "core/components";

const PatientsByCategoryReportListTemplate = function({ patientsByCategoryReportListViewStore }) { 
    const { 
        tableStore, 
        queryUtility, 
        authorization, 
        rangeQueryPickerStore,
        facilityStore,
        personStore,
        downloadUrl
        } = patientsByCategoryReportListViewStore;
        
    return (
        <ApplicationListLayout
            store={patientsByCategoryReportListViewStore}
            authorization={authorization}
        >
            <PageNavigation>
                {downloadUrl ? <a className="btn btn--base btn--ghost" href={downloadUrl}><i className="u-icon u-icon--sml u-icon--download-btn"></i>Download</a> : null}
            </PageNavigation>
            <Content>
                <div className="u-mar--bottom--sml">
                    <TableFilter queryUtility={queryUtility} showSearchFilter={false} filterVisible={true}>
                        <div className="col col-sml-12 col-med-6 col-lrg-8 col-xxlrg-4 form__group">
                            <DateRangeQueryPicker queryUtility={queryUtility} fromPropertyName="dateFrom" toPropertyName="dateTo" store={rangeQueryPickerStore} timeZone="UTC" />
                        </div>
                        <div className="col col-sml-12 col-med-6 col-lrg-4 col-xxlrg-2 form__group">
                            <QueryDropdown queryUtility={queryUtility} store={personStore} propertyName="facilityId" label="Marketing Rep" />
                        </div>
                        <div className="col col-sml-12 col-med-6 col-lrg-4 col-xxlrg-2 form__group">
                            <QueryDropdown queryUtility={queryUtility} store={facilityStore} propertyName="facilityId" label="Facility" />
                        </div>
                    </TableFilter>
                </div>
                <div className="card--table">
                    <BaasicTable
                        authorization={authorization}
                        tableStore={tableStore}
                    />
                </div>
            </Content>
        </ApplicationListLayout>
    );
};

PatientsByCategoryReportListTemplate.propTypes = {
    patientsByCategoryReportListViewStore: PropTypes.object.isRequired
};

export default defaultTemplate(PatientsByCategoryReportListTemplate);